import { render, staticRenderFns } from "./ArtworkUpload.vue?vue&type=template&id=0fb41f4f&scoped=true&"
import script from "./ArtworkUpload.vue?vue&type=script&lang=ts&"
export * from "./ArtworkUpload.vue?vue&type=script&lang=ts&"
import style0 from "./ArtworkUpload.vue?vue&type=style&index=0&id=0fb41f4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb41f4f",
  null
  
)

export default component.exports